import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditProject from "../../components/projects/FormAddEditProject";
import { useGetProject } from "../../hooks/projects/useGetProject";
import LoadingPage from "../../components/global/LoadingPage";

const EditProject = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, data } = useGetProject(id);
    const project = data?.data;

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/projects");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditProject
                isEdit={true}
                currentData={project}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditProject;